import styled from 'styled-components';

export const Dropdown = styled.div`
  position: relative;
  display: inline-block;
  z-index: ${({ $isOpen }) => ($isOpen ? '10001' : 'auto')};
`;

export const DropdownButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 6px;
  background-color: ${({ $theme }) => $theme?.bg};
  border: 1px solid ${({ $theme }) => $theme?.border};
  color: ${({ $theme }) => $theme?.text};
  border-radius: 16px;
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`;

export const DropdownIcon = styled.span`
  font-size: 8px;
  transition: transform 0.2s ease;
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

export const DropdownMenu = styled.div`
  position: absolute;
  ${({ $openUpward }) =>
    $openUpward
      ? `
    bottom: calc(100% + 4px);
  `
      : `
    top: calc(100% + 4px);
  `}
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10002;
  min-width: 140px;
  max-height: 200px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
`;

export const DropdownItem = styled.button`
  width: 100%;
  padding: 10px 16px;
  background: ${({ $isActive, $theme }) => ($isActive ? $theme?.bg : 'white')};
  border: none;
  border-left: 3px solid ${({ $theme }) => $theme?.border};
  color: #1d3557;
  font-size: 13px;
  font-weight: ${({ $isActive }) => ($isActive ? '600' : '400')};
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ $theme }) => $theme?.bg};
    opacity: 0.9;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #f0f0f0;
  }
`;
export const FlagImg = styled.img`
  width: 14px;
  height: 14px;
  mask-image: url(${({ $src }) => $src});
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;

  -webkit-mask-image: url(${({ $src }) => $src});
  -webkit-mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;

  background-color: ${({ $theme }) => $theme?.text};
`;
